import { Controller } from "stimulus";

export default class extends Controller {
  connect() {
    let options = {
      threshold: 0.4
    };

    if (
      !("IntersectionObserver" in window) ||
      !("IntersectionObserverEntry" in window) ||
      !("intersectionRatio" in window.IntersectionObserverEntry.prototype)
    ) {
      this.element.classList.add("animated");
    } else {
      let observer = new IntersectionObserver(this.animate.bind(this), options);
      observer.observe(this.element);
    }
  }

  animate(entries, observer) {
    entries.forEach(entry => {
      if (entry.isIntersecting) this.element.classList.add("animated");
    });
  }
}
